<template>
  <div class="relay-map">
    <LMap ref="map" style="height: 400px" :zoom="ZOOM" v-bind="{ center }">
      <LTileLayer :url="URL" />
      <LMarker
        v-for="marker in markersList"
        :key="marker.id"
        :lat-lng="marker.coordinates"
        :z-index-offset="isMarkerActive(marker) ? 1000 : 0"
        @click="markerClicked(marker)"
      >
        <LIcon :icon-url="marker.icon" :icon-size="ICON_SIZE" />
        <LTooltip>
          <div>{{ marker.name }}</div>
          <div>{{ marker.address }}</div>
          <div>{{ `${marker.zipcode} ${marker.city}` }}</div>
        </LTooltip>
      </LMarker>
    </LMap>
  </div>
</template>

<script>
import { Icon, latLngBounds } from 'leaflet';
import { LIcon, LMap, LMarker, LTileLayer, LTooltip } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import Relay from '../../mixins/Relay';

const DEFAULT_CENTER = [46.232193, 2.209667];
const URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const ZOOM = 5;
const ICON_SIZE = [81, 92];

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  shadowUrl: null,
});

export default {
  name: 'RelayMap',
  components: { LMap, LTileLayer, LMarker, LTooltip, LIcon },
  mixins: [Relay],
  props: {
    relaysList: {
      type: Array,
      required: true,
    },
    activeRelay: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      URL,
      ZOOM,
      ICON_SIZE,
    };
  },
  computed: {
    /**
     * @returns {Array}
     */
    center() {
      return this.activeRelay
        ? this.formatCoordinates(this.activeRelay)
        : DEFAULT_CENTER;
    },
    /**
     * @returns {Array}
     */
    markersList() {
      return this.relaysList
        .filter(relay => !relay.isPlaceholder)
        .map(relay => ({
          id: relay.pudo_id,
          coordinates: this.formatCoordinates(relay),
          icon: `/images/map/pin${
            this.isMarkerActive(relay) ? '-selected' : ''
          }.png`,
          name: relay.name,
          address: this.addressToString(relay),
          zipcode: relay.zipcode,
          city: relay.city,
        }));
    },
  },
  watch: {
    /**
     * @param {Array} array
     */
    relaysList(array) {
      const relays = array
        .filter(relay => !relay.isPlaceholder)
        .map(relay => this.formatCoordinates(relay));

      if (relays.length > 0) {
        this.$refs.map.mapObject.fitBounds(latLngBounds(relays));
      }
    },
  },
  methods: {
    /**
     * @param {string} latitude
     * @param {string} longitude
     * @returns {Array}
     */
    formatCoordinates({ latitude, longitude }) {
      return [latitude.replace(',', '.'), longitude.replace(',', '.')];
    },
    /**
     * @param {Object} marker
     */
    markerClicked(marker) {
      this.$emit('markerClicked', marker);
    },
    /**
     * @param {Object} relay
     * @returns {boolean}
     */
    isMarkerActive(relay) {
      return relay === this.activeRelay;
    },
  },
};
</script>
